module.exports = __webpack_public_path__ + "static/media/Other_Payments.1316e944.svg";